var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.HeatmapData != null)?_c('div',{staticClass:"overflow-x-auto"},[_c('highcharts',{staticStyle:{"min-width":"1000px"},attrs:{"options":_vm.HeatmapData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }